import React from 'react'

import { type DashboardAlert } from '../firestore/dashboardAlertCollection'

export interface DashboardAlertsContextValue {
  readonly loading: boolean
  readonly synced: boolean
  readonly alerts: ReadonlyArray<DashboardAlert & { isDismissed: boolean }>
  dismissAlert: (id: string) => void
}

export const DashboardAlertContext = React.createContext<DashboardAlertsContextValue>({
  alerts: [],
  loading: true,
  synced: false,
  dismissAlert: () => {},
})
